module.exports = __webpack_public_path__ + "static/media/flatbed-flatbedlorry-isometric-svgrepo-com.51bda8f9.svg";